import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="activate-links"
export default class extends Controller {
  connect() {
    // this.setActiveClassOnLoad()
  }

  // Action method to handle the click event
  activate(event) {
    event.preventDefault(); // Prevent default link behavior for demonstration; remove if you want actual navigation
    let allLinks = document.querySelectorAll("link");
    // Remove active classes from all links and add inactive classes
    allLinks.forEach((link) => {
      link.classList.remove("bg-gray-900");
      link.classList.remove("text-white");
      link.classList.add("bg-gray-100");
      link.classList.add("text-gray-700");
      link.classList.add("hover:bg-gray-200");
    });
  }
  activate_link() {
    const clickedLink = this.element;
    clickedLink.classList.remove("bg-gray-100");
    clickedLink.classList.remove("text-gray-700");
    clickedLink.classList.remove("hover:bg-gray-200");
    clickedLink.classList.add("bg-gray-900");
    clickedLink.classList.add("text-white");
  }
}
